(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-gallery-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Manual navigation (arrow, dot, swipe, drag) restarts the autoplay timer instead of advancing right after the interaction.
    document.addEventListener('slideshow:select', (event) => {
      const slideshow = event.target.closest?.('.hc-gallery slideshow-component');
      if (!slideshow || !event.detail?.userInitiated) return;
      slideshow.resume?.();
    });

    // Left/right arrow keys while focus is inside the gallery.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const slideshow = event.target.closest?.('.hc-gallery slideshow-component');
      if (!slideshow) return;
      event.preventDefault();
      event.key === 'ArrowLeft' ? slideshow.previous() : slideshow.next();
    });

    // Visitors who ask for reduced motion start paused; they can still start playback with the play button.
    const pauseForReducedMotion = (root) => {
      if (!reduceMotion.matches) return;
      customElements.whenDefined('slideshow-component').then(() => {
        root.querySelectorAll('.hc-gallery slideshow-component[autoplay]').forEach((slideshow) => slideshow.pause());
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => pauseForReducedMotion(document), { once: true });
    } else {
      pauseForReducedMotion(document);
    }
    document.addEventListener('shopify:section:load', (event) => pauseForReducedMotion(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nach-oben-button"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('scroll-top-button')) return;

    // Scrollposition von window, <html> und <body>.
    function documentScrollTop() {
      var root = document.scrollingElement || document.documentElement;
      return Math.max(
        window.pageYOffset || 0,
        root ? root.scrollTop : 0,
        document.body ? document.body.scrollTop : 0
      );
    }

    // Horizon scrollt ab 990px nicht das Fenster, sondern .page-wrapper
    // (html/body: overflow hidden, .page-wrapper: height 100dvh + overflow-y auto).
    // Deshalb den nächsten scrollbaren Vorfahren des Buttons suchen.
    function findScroller(el) {
      var node = el.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        var overflowY = getComputedStyle(node).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') return node;
        node = node.parentElement;
      }
      return null;
    }

    class ScrollTopButton extends HTMLElement {
      constructor() {
        super();
        this.ticking = false;
        this.scroller = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10) || 400;
        this.scroller = findScroller(this);

        // capture: true fängt auch Scroll-Events von Elementen wie .page-wrapper ab,
        // die nicht bis zu window/document bubbeln.
        document.addEventListener('scroll', this.handleScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.handleResize, { passive: true });

        // Klick am Host-Element abfangen statt am Button: funktioniert auch,
        // wenn das Script läuft, bevor die Kindelemente geparst sind.
        this.addEventListener('click', this.handleClick);

        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.handleScroll, { capture: true });
        window.removeEventListener('resize', this.handleResize);
        this.removeEventListener('click', this.handleClick);
      }

      handleResize() {
        // Beim Wechsel über die 990px-Grenze ändert sich der Scroll-Container.
        this.scroller = findScroller(this);
        this.handleScroll();
      }

      handleScroll(event) {
        var target = event && event.target;
        if (target && target.nodeType === 1 && target !== this.scroller && target.contains(this)) {
          this.scroller = target;
        }
        if (this.ticking) return;
        this.ticking = true;
        var self = this;
        requestAnimationFrame(function () {
          self.ticking = false;
          self.update();
        });
      }

      update() {
        // Im Theme-Editor bleibt der Button dauerhaft sichtbar (Klasse kommt aus Liquid).
        if (window.Shopify && window.Shopify.designMode) return;
        var top = documentScrollTop();
        if (this.scroller) top = Math.max(top, this.scroller.scrollTop);
        this.classList.toggle('is-visible', top > this.threshold);
      }

      handleClick(event) {
        if (!event.target.closest('button')) return;

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var options = { top: 0, behavior: reduceMotion ? 'auto' : 'smooth' };

        window.scrollTo(options);
        [this.scroller, document.scrollingElement, document.documentElement, document.body].forEach(function (el) {
          if (el && el.scrollTop > 0 && typeof el.scrollTo === 'function') {
            el.scrollTo(options);
          }
        });
      }
    }

    customElements.define('scroll-top-button', ScrollTopButton);
  })();

  } catch(e) { console.error(e); }
})();
})();
